<template lang="pug">
.section
  .section-header
    .section-header-back
      a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect()")
        i.fas.fa-arrow-left
    h1 {{ $t("ui.affiliate_report") }}
    .section-header-breadcrumb
      .breadcrumb-item
        router-link(to="/affiliate/affiliateList") {{ $t("ui.affiliate_list") }}
      .breadcrumb-item.active
        router-link(to="/affiliate/affiliateReport") {{ $t('ui.affiliate_report') }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-body
            .row
              .col-12.mb-3 
                .section-title.m-1 
                  span {{ affiliateID }}
              .col-12 
                ul#affiliatetab.nav.nav-tabs(role='tablist')
                  li.nav-item(v-if="showActionButton('bankaff')" @click="refresh('bankaff')")
                    a#bankaff-tab.nav-link.active(data-toggle='tab' href='#bankaff-content' role='tab' aria-controls='bankaff' aria-selected='false') {{ $t("ui.bank_affiliate") }}
                  li.nav-item(v-if="showActionButton('dailystatementaff')" @click="refresh('dailystatementaff')")
                    a#dailystatementaff-tab.nav-link(data-toggle='tab' href='#dailystatementaff-content' role='tab' aria-controls='dailystatementaff' aria-selected='false') {{ $t("ui.daily_statement_affiliate") }}
                  li.nav-item(v-if="showActionButton('dailydepositaff')" @click="refresh('dailydepositaff')")
                    a#dailydepositaff-tab.nav-link(data-toggle='tab' href='#dailydepositaff-content' role='tab' aria-controls='dailydepositaff' aria-selected='false') {{ $t("ui.daily_deposit_affiliate") }}
                  li.nav-item(v-if="showActionButton('dailywinloseaff')" @click="refresh('dailywinloseaff')")
                    a#dailywinloseaff-tab.nav-link(data-toggle='tab' href='#dailywinloseaff-content' role='tab' aria-controls='dailywinloseaff' aria-selected='false') {{ $t("ui.daily_winlose_affiliate") }}
                  li.nav-item(v-if="showActionButton('settlementlogaffiliate')" @click="refresh('settlementlogaffiliate')")
                    a#settlementlogaffiliate-tab.nav-link(data-toggle='tab' href='#settlementlogaffiliate-content' role='tab' aria-controls='settlementlogaffiliate' aria-selected='false') {{ $t("ui.settlement_list_affiliate") }}

                #affiliatetabcontent.tab-content.tab-bordered
                  #bankaff-content.tab-pane.active.show(v-if="showActionButton('bankaff') && currTab == 'bankaff'" role='tabpanel' aria-labelledby='bankaff-tab')
                    bankAffTab(ref="bankAffTab")
                  #dailystatementaff-content.tab-pane.fade(v-if="showActionButton('dailystatementaff') && currTab == 'dailystatementaff'" role='tabpanel' aria-labelledby='dailystatementaff-tab')
                    dailyStatementAffTab(ref="dailyStatementAffTab")
                  #dailydepositaff-content.tab-pane.fade(v-if="showActionButton('dailydepositaff') && currTab == 'dailydepositaff'" role='tabpanel' aria-labelledby='dailydepositaff-tab')
                    dailyDepositAffTab(
                      ref="dailyDepositAffTab"
                      :selected-affiliate-id="affiliateID"
                      :shared-lines="affiliateLines"
                      @affiliate-lines-update="affiliateLines = $event"
                    )
                  #dailywinloseaff-content.tab-pane.fade(v-if="showActionButton('dailywinloseaff') && currTab == 'dailywinloseaff'" role='tabpanel' aria-labelledby='dailywinloseaff-tab')
                    dailyWinloseAffTab(
                      ref="dailyWinloseAffTab"
                      :selected-affiliate-id="affiliateID"
                      :shared-lines="affiliateLines"
                      @affiliate-lines-update="affiliateLines = $event"
                    )
                  #settlementlogaffiliate-content.tab-pane.fade(v-if="showActionButton('settlementlogaffiliate') && currTab == 'settlementlogaffiliate'" role='tabpanel' aria-labelledby='settlementlogaffiliate-tab')
                    settlementListAffTab(ref="settlementListAffTab")



</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

import bankAffTab from "@/components/affiliate/bankAffTab.vue";
import dailyStatementAffTab from "@/components/affiliate/dailyStatementAffTab.vue";
import dailyDepositAffTab from "@/components/affiliate/dailyDepositAffTab.vue";
import dailyWinloseAffTab from "@/components/affiliate/dailyWinloseAffTab.vue";
import settlementListAffTab from "@/components/affiliate/settlementListAffTab.vue";

export default {
  components: {
    bankAffTab,
    dailyStatementAffTab,
    dailyDepositAffTab,
    dailyWinloseAffTab,
    settlementListAffTab
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currTab: 'bankaff',
    affiliateLines: []
  }),
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    affiliateID() {
      return this.$store.getters.selectedAffiliateID;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {  },
  destroyed: function() {  },
  methods: {
    redirect() {
      this.$router.push("/affiliate/affiliateList");
    },
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    refresh: function(tab) {
      switch(tab) {
        case 'bankaff':
          this.currTab = 'bankaff'
          this.$nextTick(() => {
            if(this.$refs.bankAffTab) {
              this.$refs.bankAffTab.refresh();
            }
          });
          break
        case 'dailystatementaff':
          this.currTab = 'dailystatementaff'
          this.$nextTick(() => {
            if(this.$refs.dailyStatementAffTab) {
              this.$refs.dailyStatementAffTab.refresh();
            }
          });
          break
        case 'dailydepositaff':
          this.currTab = 'dailydepositaff'
          this.$nextTick(() => {
            if(this.$refs.dailyDepositAffTab) {
              this.$refs.dailyDepositAffTab.refresh();
            }
          });
          break
        case 'dailywinloseaff':
          this.currTab = 'dailywinloseaff'
          this.$nextTick(() => {
            if(this.$refs.dailyWinloseAffTab) {
              this.$refs.dailyWinloseAffTab.refresh();
            }
          });
          break
        case 'settlementlogaffiliate':
          this.currTab = 'settlementlogaffiliate'
          this.$nextTick(() => {
            if(this.$refs.settlementListAffTab) {
              this.$refs.settlementListAffTab.refresh();
            }
          });
          break
      }
    },
  }
}
</script>